<div id="all-elements" class="{{ isAndroid() || isIOSDevice() ? 'all-elements-mobile' : '' }}" class="full-size" style="overflow:hidden;" (click)="onAnywhereClick($event);"
	(mousemove)="onMouseMove();">

	<!-- video -->
	<video #player [defaultPlaybackRate]="playbackRate" [playbackRate]="playbackRate" preload="auto"
		disablePictureInPicture [loop]="data.loop && !currentPlayCountdown" crossorigin="anonymous" class="full-size"
		[style]="'background-color: ' + data.videoData.bgColor + ';'" playsinline (play)="hidePoster();"
		(timeupdate)="onTimeUpdate($event);" (loadeddata)="onVideoLoaded($event)"
		(loadedmetadata)="onLoadedMetadata($event);" controlsList="nodownload" (click)="onPlayerClick($event);"
		[class.hidden]="videoData.floatingEnabled && !currentPlayCountdown" [poster]="videoData.poster" id="video-element"></video>


	<!-- tags -->
	<div [style]="getVideoOverlapStyles()" class="video-overlap" id="overlapper" (click)="$event.stopImmediatePropagation()" style="z-index: 9999;">
		<canvas #canvas class="canvas_object" *ngIf="videoData.floatingEnabled && !currentPlayCountdown">
		</canvas>

		<div class="for_tags" *ngIf="playerPlayed" >
			<div class="image_tag" *ngFor="let tag of videoData.getImageTags()" [style]="getTagStyles(tag)" 
				style="z-index: 9999;">
				<img [src]="tag.getImageURL()" alt="" *ngIf="isTagCurrentlyVisible(tag)" class="tag_img"
					(click)="$event.stopImmediatePropagation(); onTagClick(tag)"
					[@expander_horizontal]="tag.transitionScale === 'horizontal' ? 'work' : ''"
					[@expander_vertical]="tag.transitionScale === 'vertical' ? 'work' : ''"
					[@fader]="tag.transitionFade ? 'work' : ''"
					[@from_right]="tag.transitionMove === 'right' ? 'work' : ''"
					[@from_left]="tag.transitionMove === 'left' ? 'work' : ''"
					[@from_top]="tag.transitionMove === 'top' ? 'work' : ''"
					[@from_bottom]="tag.transitionMove === 'bottom' ? 'work' : ''"
					[@rotation]="tag.transitionMove === 'rotation' ? 'work' : ''" />
			</div>
		</div>
	</div>

	<!-- posters -->
	<div class="poster" *ngIf="!data.autoplay && player.currentTime == 0 && videoData.poster!=''"
		[style]="'background-color: ' + data.videoData.bgColor + ';'">
		<img [src]="getPosterUrl()" class="full-size" [style]="'object-fit: ' + videoData.posterFit" />
	</div>

	<div class="poster" *ngIf="player.paused && player.currentTime > 0 && videoData.posterPause!=''"
		[style]="'background-color: ' + data.videoData.bgColor + ';'">
		<img [src]="getPausePosterUrl()" class="full-size" [style]="'object-fit: ' + videoData.posterPauseFit" />
	</div>

	<div class="poster" *ngIf="player.paused && player.currentTime == player.duration && videoData.posterEnd!=''"
		[style]="'background-color: ' + data.videoData.bgColor + ';'">
		<img [src]="getEndPosterUrl()" class="full-size" [style]="'object-fit: ' + videoData.posterEndFit" />
	</div>

	<!-- CONTROLS ENABLED ?controls=1 -->
	<div *ngIf="data.controls"
		[class.hidden]="!showPlayerControls"
		class="alter-controls">
		<div class="toolBox">
			<div class="toolDiv" >

				<div *ngIf="videoData.enablePlayButton">
					<!-- play -->
					<div class="small-icon" *ngIf="player.paused" title="Play"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); player.play(); unmuteAction()">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M22 12.7679C23.3333 13.5377 23.3333 15.4622 22 16.2321L13.75 20.9952C12.4167 21.765 10.75 20.8027 10.75 19.2631L10.75 9.73686C10.75 8.19726 12.4167 7.23501 13.75 8.00481L22 12.7679Z"
								[attr.fill]="videoData.primaryColor" id="palyIconSt" />
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" id="palyIconTr" />
						</svg>
					</div>

					<!-- pause -->
					<div class="small-icon" *ngIf="!player.paused" title="Pause"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); player.pause();">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<path
								d="M11.5409 24.4351C11.5403 24.9178 11.0812 25.2906 10.5145 25.2678C9.94789 25.2449 9.48838 24.8359 9.48855 24.3531L9.49128 5.71835C9.49148 5.23599 9.95114 4.86306 10.518 4.88576C11.0844 4.90823 11.5438 5.3178 11.544 5.80026L11.5409 24.4351Z"
								[attr.fill]="videoData.primaryColor" />
							<path
								d="M19.7421 24.4351C19.7415 24.9178 19.2824 25.2906 18.7157 25.2678C18.1491 25.2449 17.6895 24.8359 17.6897 24.3531L17.6924 5.71835C17.6926 5.23599 18.1523 4.86306 18.7191 4.88576C19.2855 4.90823 19.7449 5.3178 19.7452 5.80026L19.7421 24.4351Z"
								[attr.fill]="videoData.primaryColor" />
						</svg>
					</div>
				</div>

				<!-- progress bar -->
				<div class="progressbar" [style]="'height: ' + videoData.progressbarHeight + 'px; '"
					(click)="$event.stopImmediatePropagation(); setProgress($event);"
					*ngIf="videoData.enableProgressbar">

					<div class="progress-time" *ngIf="videoData.enableTime && videoData.enableProgressbar">
						<small [style]="'color: ' + videoData.primaryColor + ';'" >
							{{ formatDuration(currentTimeS) }}
						</small>
						<small [style]="'color: ' + videoData.primaryColor + ';'" >
							{{ formattedDuration }}
						</small>
					</div>

					<div class="progressLine" [class.padding]="videoData.enableTime"
						[style]="'background-color: ' + videoData.primaryColor + '; height: ' + videoData.progressbarHeight + 'px; width: ' + (player.currentTime / player.duration) * 100 + '%; '" >
					</div>
				</div>

				<!-- progress time -->
				<div class="time" *ngIf="videoData.enableTime && !videoData.enableProgressbar">
					<small [style]="'color: ' + videoData.primaryColor + ';'">
						{{ formatDuration(currentTimeS) }}
					</small>
					<small [style]="'color: ' + videoData.primaryColor + ';'">
						{{ formattedDuration }}
					</small>
				</div>

				<!-- volume -->
				<div class="volume_bar" title="Volume" (mouseover)="isSelectVisible = false;"
					*ngIf="videoData.enableVolume">
					<div class="volume_popup" *ngIf="!isAndroid() && !isIOSDevice()">
						<div class="volume_bg" (click)="$event.stopImmediatePropagation(); setVolume($event);">
							<div style="width: 10px; border-radius: 100px;"
								[style]="'background-color: ' + videoData.primaryColor + '; height: ' + (player?.volume ?? 0) * 100 + '%;'"
								(click)="$event.stopImmediatePropagation(); setVolume($event);">
							</div>
						</div>
					</div>

					<div class="small-icon" *ngIf="videoData.enableVolume && player.volume > 0 && player.muted === false"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); muteVideo()">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M14.3472 6.70449C14.5184 6.67672 14.6968 6.70568 14.8636 6.79424C15.1964 6.96943 15.4028 7.33879 15.4028 7.75907V21.9212C15.4028 22.3405 15.1955 22.7099 14.8636 22.8861C14.7376 22.9521 14.6052 22.9852 14.4742 22.9852C14.2582 22.9852 14.0458 22.8966 13.8731 22.7252L10.2436 19.1482H7.47913C6.78936 19.1482 6.22803 18.5039 6.22803 17.7122V11.9681C6.22803 11.1763 6.78936 10.532 7.47913 10.532H10.2436L13.8731 6.95504C14.0116 6.81766 14.176 6.73225 14.3472 6.70449ZM19.6416 9.57656C19.9614 9.59702 20.2752 9.75615 20.505 10.0515C21.5375 11.3746 22.1063 13.0748 22.1063 14.8401C22.1063 16.6055 21.5375 18.3057 20.505 19.6288C20.2581 19.9457 19.9152 20.1056 19.5715 20.1056C19.2746 20.1056 18.976 19.9852 18.7374 19.7391C18.2228 19.2097 18.1801 18.301 18.6413 17.7103C19.2619 16.9148 19.6041 15.8961 19.6041 14.8401C19.6041 13.7842 19.2619 12.7655 18.6413 11.9699C18.1801 11.3793 18.2228 10.4706 18.7374 9.94117C18.9948 9.67503 19.3217 9.55609 19.6416 9.57656Z"
								[attr.fill]="videoData.primaryColor" />
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
						</svg>
					</div>

					<div class="small-icon" *ngIf="videoData.enableVolume && player.volume == 0 || player.muted"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); umuteVideo();">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<path
								d="M15.1192 6.01015C15.2903 5.98239 15.4687 6.01135 15.6356 6.0999C15.9684 6.2751 16.1748 6.64446 16.1748 7.06474V21.2269C16.1748 21.6462 15.9675 22.0156 15.6356 22.1917C15.5096 22.2578 15.3772 22.2908 15.2462 22.2908C15.0302 22.2908 14.8178 22.2023 14.6451 22.0309L11.0156 18.4539H8.2511C7.56133 18.4539 7 17.8096 7 17.0179V11.2737C7 10.482 7.56133 9.83771 8.2511 9.83771H11.0156L14.6451 6.26071C14.7836 6.12333 14.948 6.03791 15.1192 6.01015ZM20.4135 8.88222C20.7334 8.90268 21.0471 9.06181 21.2769 9.35716C22.3095 10.6802 22.8783 12.3804 22.8783 14.1458C22.8783 15.9112 22.3095 17.6114 21.2769 18.9345C21.03 19.2513 20.6871 19.4113 20.3435 19.4113C20.0466 19.4113 19.748 19.2908 19.5094 19.0448C18.9948 18.5154 18.9521 17.6067 19.4133 17.016C20.0339 16.2204 20.3761 15.2018 20.3761 14.1458C20.3761 13.0898 20.0339 12.0712 19.4133 11.2756C18.9521 10.6849 18.9948 9.77626 19.5094 9.24684C19.7667 8.98069 20.0937 8.86176 20.4135 8.88222Z"
								[attr.fill]="videoData.primaryColor" />
							<path
								d="M19.582 22.4193C19.8004 22.8498 19.5604 23.3903 19.0451 23.627C18.5298 23.8638 17.9347 23.7078 17.7158 23.2775L9.26349 6.66983C9.04482 6.23988 9.28525 5.69899 9.80069 5.46204C10.3156 5.22509 10.9108 5.38166 11.1299 5.81148L19.582 22.4193Z"
								[attr.fill]="videoData.primaryColor" />
						</svg>
					</div>
				</div>

				<!-- unmute label -->
				<span (click)="$event.stopImmediatePropagation(); player.muted = false" class="unmute_label"
					style="bottom: 50px; z-index: 20"
					*ngIf="currentPlayCountdown || (videoData.showUnmute && player.muted)">{{videoData.unmuteLabel}}</span>

				<!-- speed -->
				<div title="Playback speed" *ngIf="data.speed"
					style="position: relative; display: inline-block; align-items: center; justify-content: center;">

					<div class="small-icon" [style]="'color: ' + videoData.primaryColor + ';'"
						(click)="toggleSelectVisibility($event); $event.stopImmediatePropagation()">

						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
							*ngIf="!isSelectVisible">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<g clip-path="url(#clip0_2060_7473)">
								<path
									d="M21.8803 15.8945C21.5621 15.6611 21.372 15.2862 21.372 14.8912C21.372 14.4963 21.5621 14.1214 21.8798 13.8884L23.3499 12.8106C23.5842 12.6383 23.6811 12.3353 23.5896 12.0591C23.2111 10.9219 22.6127 9.88472 21.8102 8.97562C21.617 8.75783 21.3055 8.6891 21.039 8.80603L19.3837 9.53393C19.0231 9.69281 18.6032 9.67005 18.2609 9.47234C17.919 9.27508 17.6896 8.9234 17.6463 8.53111L17.4473 6.7138C17.4156 6.42461 17.2005 6.18896 16.9157 6.1305C15.7567 5.89352 14.5388 5.8895 13.3592 6.12604C13.0727 6.18361 12.8571 6.41925 12.8255 6.70979L12.6282 8.51549C12.5849 8.90823 12.3555 9.25991 12.0127 9.45717C11.6709 9.65443 11.2523 9.67808 10.8903 9.51876L9.2261 8.78684C8.96189 8.66991 8.64948 8.73774 8.45624 8.95509C7.65113 9.86062 7.04997 10.8965 6.6675 12.0327C6.57467 12.3085 6.67107 12.6134 6.90626 12.7861L8.36698 13.8572C8.68563 14.091 8.87576 14.4659 8.87576 14.8609C8.87576 15.2559 8.68563 15.6307 8.36787 15.8637L6.89778 16.9415C6.66348 17.1138 6.56663 17.4168 6.65812 17.6931C7.03658 18.8302 7.63506 19.8674 8.4375 20.7765C8.63074 20.9947 8.94315 21.0639 9.20869 20.9461L10.864 20.2182C11.2246 20.0593 11.6441 20.0821 11.9869 20.2798C12.3287 20.477 12.5581 20.8287 12.6014 21.221L12.8005 23.0383C12.8321 23.3275 13.0473 23.5632 13.332 23.6216C13.9184 23.7412 14.5209 23.8019 15.1239 23.8019C15.7121 23.8019 16.3056 23.7426 16.8881 23.6256C17.1746 23.5681 17.3901 23.3324 17.4218 23.0419L17.6195 21.2362C17.6628 20.8434 17.8922 20.4918 18.235 20.2945C18.5768 20.0977 18.9959 20.0745 19.3574 20.2329L21.0216 20.9648C21.2867 21.0822 21.5982 21.0144 21.7915 20.7966C22.5966 19.8911 23.1978 18.8552 23.5802 17.7189C23.6731 17.4431 23.5767 17.1383 23.3415 16.9656L21.8803 15.8945ZM15.1239 18.0001C13.3985 18.0001 11.9998 16.6014 11.9998 14.8761C11.9998 13.1507 13.3985 11.752 15.1239 11.752C16.8492 11.752 18.2479 13.1507 18.2479 14.8761C18.2479 16.6014 16.8492 18.0001 15.1239 18.0001Z"
									[attr.fill]="videoData.primaryColor" />
							</g>
							<defs>
								<clipPath id="clip0_2060_7473">
									<rect width="17.8512" height="17.8512" fill="white"
										transform="translate(6.19824 5.95068)" />
								</clipPath>
							</defs>
						</svg>

						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
							*ngIf="isSelectVisible">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM21.372 14.8912C21.372 15.2862 21.5621 15.6611 21.8803 15.8945L23.3415 16.9656C23.5767 17.1383 23.6731 17.4431 23.5802 17.7189C23.1978 18.8552 22.5966 19.8911 21.7915 20.7966C21.5982 21.0144 21.2867 21.0822 21.0216 20.9648L19.3574 20.2329C18.9959 20.0745 18.5768 20.0977 18.235 20.2945C17.8922 20.4918 17.6628 20.8434 17.6195 21.2362L17.4218 23.0419C17.3901 23.3324 17.1746 23.5681 16.8881 23.6256C16.3056 23.7426 15.7121 23.8019 15.1239 23.8019C14.5209 23.8019 13.9184 23.7412 13.332 23.6216C13.0473 23.5632 12.8321 23.3275 12.8005 23.0383L12.6014 21.221C12.5581 20.8287 12.3287 20.477 11.9869 20.2798C11.6441 20.0821 11.2246 20.0593 10.864 20.2182L9.20869 20.9461C8.94315 21.0639 8.63074 20.9947 8.4375 20.7765C7.63506 19.8674 7.03658 18.8302 6.65812 17.6931C6.56663 17.4168 6.66348 17.1138 6.89778 16.9415L8.36787 15.8637C8.68563 15.6307 8.87576 15.2559 8.87576 14.8609C8.87576 14.4659 8.68563 14.091 8.36698 13.8572L6.90626 12.7861C6.67107 12.6134 6.57467 12.3085 6.6675 12.0327C7.04997 10.8965 7.65113 9.86062 8.45624 8.95509C8.64948 8.73774 8.96189 8.66991 9.2261 8.78684L10.8903 9.51876C11.2523 9.67808 11.6709 9.65443 12.0127 9.45717C12.3555 9.25991 12.5849 8.90823 12.6282 8.51549L12.8254 6.70979C12.8571 6.41925 13.0727 6.18361 13.3592 6.12604C14.5388 5.8895 15.7567 5.89352 16.9157 6.1305C17.2005 6.18896 17.4156 6.42461 17.4473 6.7138L17.6463 8.53111C17.6896 8.9234 17.919 9.27508 18.2609 9.47234C18.6032 9.67005 19.0231 9.69281 19.3837 9.53393L21.039 8.80603C21.3055 8.6891 21.617 8.75783 21.8102 8.97562C22.6127 9.88472 23.2111 10.9219 23.5896 12.0591C23.6811 12.3353 23.5842 12.6383 23.3499 12.8106L21.8798 13.8884C21.5621 14.1214 21.372 14.4963 21.372 14.8912ZM11.9998 14.8761C11.9998 16.6014 13.3985 18.0001 15.1239 18.0001C16.8492 18.0001 18.2479 16.6014 18.2479 14.8761C18.2479 13.1507 16.8492 11.752 15.1239 11.752C13.3985 11.752 11.9998 13.1507 11.9998 14.8761Z"
								[attr.fill]="videoData.primaryColor" />
						</svg>

					</div>

					<div [class.hidden]="!isSelectVisible" id="playbackRate" class="playback-rate-selector" >
						<div class="custom-dropdown">
							<div class="selected-option">
								<img src="assets/spd.svg" class="icon" />
								Playback Speed
							</div>
							<div style="color: #54779E;">
								<div class="playback-rate-option" (click)="$event.stopImmediatePropagation(); setPlaybackRate(option)"
									*ngFor="let option of [0.5,1,1.2,1.5,2]"
									[style]="{'background': playbackRate === option ? '#F8FAFD' : 'inherit'}">
									<span class="check-containter">
										<img src="assets/check.svg" *ngIf="playbackRate !== option">
										<img src="assets/checked.svg" *ngIf="playbackRate === option">
									</span>
									<span [style]="{'color': playbackRate === option ? '#425E7D' : 'inherit'}">{{option}}x</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- fullcreen -->
				<div *ngIf="videoData.enableFullscreen">
					<div class="small-icon" *ngIf="!isFullscreen" title="Fullscreen"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); openFullscreen();" id="fullscreenButton">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<path
								d="M7.93367 17.8513H5.9502V21.8182C5.9502 22.9091 6.84276 23.8017 7.93367 23.8017H11.9006V21.8182H7.93367M7.93367 7.93391H11.9006V5.95044H7.93367C6.84276 5.95044 5.9502 6.843 5.9502 7.93391V11.9009H7.93367M21.818 5.95044H17.851V7.93391H21.818V11.9009H23.8014V7.93391C23.8014 6.843 22.9089 5.95044 21.818 5.95044ZM21.818 21.8182H17.851V23.8017H21.818C22.9089 23.8017 23.8014 22.9091 23.8014 21.8182V17.8513H21.818"
								[attr.fill]="videoData.primaryColor" />
						</svg>

					</div>

					<div class="small-icon" *ngIf="isFullscreen" title="Exit Fullscreen"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); closeFullscreen();">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd"
								d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM23.8512 11.9504H19.8843C18.7934 11.9504 17.9008 11.0579 17.9008 9.96694V6H19.8843V9.96694H23.8512V11.9504ZM11.8512 9.96695V6H9.86776V9.96695H5.90082V11.9504H9.86776C10.9587 11.9504 11.8512 11.0579 11.8512 9.96695ZM5.90082 18H9.86776C10.9587 18 11.8512 18.8926 11.8512 19.9835V23.9504H9.86776V19.9835H5.90082V18ZM17.9008 19.9835V23.9504H19.8843V19.9835H23.8512V18H19.8843C18.7934 18 17.9008 18.8926 17.9008 19.9835Z"
								[attr.fill]="videoData.primaryColor" />
						</svg>
					</div>
				</div>

				<!-- builderall logo -->
				<div title="Builderall" *ngIf="videoData.enableLogo && (!isAndroid() && !isIOSDevice())" (click)="$event.stopImmediatePropagation()">
					<a [href]="logoLink" target="_blank">
						<img src="assets/ba.svg" alt="Builderall" *ngIf="videoData.primaryColor == '#0072E1'"/>
						<img src="assets/ba-black.svg" alt="Builderall" *ngIf="videoData.primaryColor != '#0072E1'"/>
					</a>
				</div>

				<div title="Builderall" *ngIf="videoData.enableLogo && (isAndroid() || isIOSDevice())" (click)="$event.stopImmediatePropagation()">
					<a [href]="logoLink" target="_blank">
						<img src="assets/octopus.svg" alt="Builderall" *ngIf="videoData.primaryColor == '#0072E1'"/>
						<img src="assets/octopus-black.svg" alt="Builderall" *ngIf="videoData.primaryColor != '#0072E1'"/>
					</a>
				</div>
			</div>
		</div>

		<!-- centered main icons -->
		<div class="center-controls" *ngIf="showPlayerControls">

			<!-- back 10 -->
			<div *ngIf="videoData.enableBack10 && !loading" (click)="$event.stopImmediatePropagation(); moveForSeconds(-10);"  class="pointer"
				title="Back 10sec">
				<svg xmlns="http://www.w3.org/2000/svg" width="90" height="98" viewBox="0 0 90 98" fill="none" >
					<g filter="url(#filter0_f_31_130)">
						<path
							d="M24.1239 31.8761C25.0374 30.9626 25.9805 30.1715 26.9057 29.4517C27.2442 29.1776 27.6339 28.9738 28.0521 28.8522C28.4703 28.7306 28.9086 28.6936 29.3413 28.7434C29.774 28.7932 30.1924 28.9288 30.572 29.1422C30.9517 29.3556 31.2849 29.6427 31.5523 29.9864C31.8197 30.3302 32.0159 30.7239 32.1293 31.1444C32.2427 31.5649 32.2711 32.0038 32.2129 32.4354C32.1546 32.8671 32.0109 33.2827 31.7901 33.6581C31.5693 34.0335 31.2758 34.3611 30.9268 34.6218C30.1405 35.2336 29.4146 35.849 28.7557 36.508C19.7743 45.4893 19.7743 59.9493 28.7557 68.9306C37.737 77.912 52.197 77.912 61.1784 68.9306C70.1597 59.9493 70.1597 45.4893 61.1784 36.508C58.1271 33.4567 54.439 31.4796 50.551 30.5124L50.7568 30.7182C51.068 31.0207 51.316 31.3821 51.4863 31.7813C51.6567 32.1806 51.746 32.6097 51.7491 33.0437C51.7521 33.4777 51.6689 33.908 51.5042 34.3096C51.3395 34.7112 51.0967 35.0761 50.7898 35.383C50.4829 35.6899 50.118 35.9328 49.7164 36.0974C49.3148 36.2621 48.8845 36.3453 48.4505 36.3423C48.0164 36.3392 47.5873 36.2499 47.1881 36.0796C46.7889 35.9092 46.4275 35.6612 46.125 35.35L39.7698 28.9948L39.1772 28.4023C38.5631 27.788 38.2181 26.955 38.2181 26.0864C38.2181 25.2178 38.5631 24.3847 39.1772 23.7705L46.125 16.8228C46.4275 16.5115 46.7889 16.2635 47.1881 16.0932C47.5873 15.9228 48.0164 15.8335 48.4505 15.8305C48.8845 15.8274 49.3148 15.9106 49.7164 16.0753C50.118 16.24 50.4829 16.4829 50.7898 16.7898C51.0967 17.0967 51.3395 17.4615 51.5042 17.8631C51.6689 18.2647 51.7521 18.695 51.7491 19.1291C51.746 19.5631 51.6567 19.9922 51.4863 20.3914C51.316 20.7906 51.068 21.152 50.7568 21.4546L48.7077 23.5036C54.9626 24.2982 61.0181 27.084 65.8102 31.8761C77.2945 43.3604 77.2945 62.0782 65.8102 73.5625C54.3259 85.0468 35.6082 85.0468 24.1239 73.5625C12.6396 62.0782 12.6396 43.3604 24.1239 31.8761Z"
							[attr.fill]="videoData.secondaryColor" fill-opacity="0.6" />
					</g>
					<path
						d="M29.31 36.69C29.9967 36.0033 30.7055 35.4088 31.4008 34.8678C31.6552 34.6618 31.9481 34.5086 32.2624 34.4172C32.5767 34.3258 32.9061 34.298 33.2313 34.3355C33.5565 34.3729 33.871 34.4748 34.1563 34.6352C34.4416 34.7956 34.6921 35.0113 34.8931 35.2697C35.094 35.5281 35.2415 35.824 35.3267 36.14C35.4119 36.456 35.4333 36.7859 35.3895 37.1103C35.3458 37.4347 35.2377 37.7471 35.0718 38.0293C34.9058 38.3114 34.6852 38.5576 34.423 38.7535C33.832 39.2133 33.2864 39.6759 32.7912 40.1711C26.041 46.9213 26.041 57.789 32.7912 64.5392C39.5413 71.2893 50.4091 71.2893 57.1592 64.5392C63.9094 57.789 63.9094 46.9213 57.1592 40.1711C54.866 37.8779 52.0941 36.392 49.172 35.665L49.3266 35.8197C49.5606 36.0471 49.7469 36.3187 49.875 36.6187C50.003 36.9188 50.0701 37.2412 50.0724 37.5675C50.0747 37.8937 50.0122 38.2171 49.8884 38.5189C49.7646 38.8207 49.5821 39.0949 49.3514 39.3256C49.1208 39.5563 48.8466 39.7388 48.5447 39.8626C48.2429 39.9863 47.9195 40.0489 47.5933 40.0466C47.2671 40.0443 46.9446 39.9772 46.6445 39.8491C46.3445 39.7211 46.0729 39.5347 45.8455 39.3008L41.0691 34.5244L40.6238 34.0791C40.1622 33.6174 39.9029 32.9913 39.9029 32.3385C39.9029 31.6857 40.1622 31.0596 40.6238 30.598L45.8455 25.3762C46.0729 25.1423 46.3445 24.9559 46.6445 24.8279C46.9446 24.6999 47.2671 24.6328 47.5933 24.6305C47.9195 24.6281 48.2429 24.6907 48.5447 24.8145C48.8466 24.9382 49.1208 25.1208 49.3514 25.3514C49.5821 25.5821 49.7646 25.8563 49.8884 26.1581C50.0122 26.46 50.0747 26.7834 50.0724 27.1096C50.0701 27.4358 50.003 27.7583 49.875 28.0583C49.7469 28.3584 49.5606 28.63 49.3266 28.8574L47.7866 30.3974C52.4876 30.9945 57.0388 33.0883 60.6404 36.69C69.2717 45.3213 69.2717 59.389 60.6404 68.0203C52.0091 76.6516 37.9413 76.6516 29.31 68.0203C20.6787 59.389 20.6787 45.3213 29.31 36.69Z"
						[attr.fill]="videoData.primaryColor" />
					<defs>
						<filter id="filter0_f_31_130" x="0.51062" y="0.830322" width="88.9128" height="96.3455"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="7.5" result="effect1_foregroundBlur_31_130" />
						</filter>
					</defs>
				</svg>
			</div>

			<!-- play -->
			<div *ngIf="videoData.enablePlayButton && (player.paused && (!loading || canPlay))" class="pointer center-icon" title="Play"
				(click)="$event.stopImmediatePropagation(); player.play(); unmuteAction();">
				<svg xmlns="http://www.w3.org/2000/svg" width="131" height="140" viewBox="0 0 131 140" fill="none">
					<g filter="url(#filter0_f_31_126)">
						<path
							d="M98 64.8038C102 67.1132 102 72.8868 98 75.1962L39.5 108.971C35.5 111.281 30.5 108.394 30.5 103.775L30.5 36.225C30.5 31.6062 35.5 28.7195 39.5 31.0289L98 64.8038Z"
							[attr.fill]="videoData.secondaryColor" fill-opacity="0.6" />
					</g>
					<g filter="url(#filter1_d_31_126)">
						<path
							d="M91 64.5707C95 66.8801 95 72.6536 91 74.963L43.3497 102.474C39.3497 104.783 34.3497 101.897 34.3497 97.2777L34.3497 42.2559C34.3497 37.6371 39.3497 34.7504 43.3497 37.0598L91 64.5707Z"
							[attr.fill]="videoData.primaryColor" />
					</g>
					<defs>
						<filter id="filter0_f_31_126" x="0.5" y="0.216064" width="130.5" height="139.568"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="15" result="effect1_foregroundBlur_31_126" />
						</filter>
						<filter id="filter1_d_31_126" x="30.3497" y="36.2471" width="67.6503" height="75.0396"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix in="SourceAlpha" type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
							<feOffset dy="4" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_126" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_31_126" result="shape" />
						</filter>
					</defs>
				</svg>
			</div>

			<!-- pause -->
			<mat-spinner 
			*ngIf="loading && (!canPlay || (canPlay && !player.paused))" 
			[style.--mdc-circular-progress-active-indicator-color]="videoData.primaryColor">
		  </mat-spinner>
			<!-- <mat-spinner *ngIf="loading && !canPlay" [style.--mdc-circular-progress-active-indicator-color]="videoData.primaryColor"></mat-spinner> -->


			<div *ngIf="videoData.enablePlayButton && !player.paused && !loading && canPlay" class="pointer center-icon" title="Pause"
				(click)="$event.stopImmediatePropagation(); player.pause();">

				<svg xmlns="http://www.w3.org/2000/svg" width="81" height="121" viewBox="0 0 81 121" fill="none">
					<g filter="url(#filter0_f_1_495)">
						<path
							d="M28.4456 97.3566C28.4432 99.2486 26.6438 100.709 24.423 100.62C22.2022 100.531 20.4012 98.9276 20.4019 97.0353L20.4126 24.0009C20.4134 22.1104 22.2149 20.6488 24.4365 20.7378C26.6563 20.8259 28.4567 22.4311 28.4577 24.322L28.4456 97.3566Z"
							[attr.fill]="videoData.secondaryColor" />
						<path
							d="M60.5878 97.3566C60.5854 99.2486 58.786 100.709 56.5652 100.62C54.3443 100.531 52.5434 98.9276 52.544 97.0353L52.5547 24.0009C52.5555 22.1104 54.357 20.6488 56.5786 20.7378C58.7985 20.8259 60.5989 22.4311 60.5999 24.322L60.5878 97.3566Z"
							[attr.fill]="videoData.secondaryColor" />
					</g>
					<path
						d="M31.3564 89.885C31.3545 91.3985 29.915 92.5672 28.1383 92.4957C26.3617 92.4242 24.9209 91.1418 24.9215 89.6279L24.93 31.2007C24.9306 29.6884 26.3718 28.5191 28.1491 28.5902C29.925 28.6607 31.3653 29.9449 31.3661 31.4576L31.3564 89.885Z"
						[attr.fill]="videoData.primaryColor" />
					<path
						d="M57.07 89.885C57.0681 91.3985 55.6285 92.5672 53.8519 92.4957C52.0752 92.4242 50.6345 91.1418 50.635 89.6279L50.6436 31.2007C50.6442 29.6884 52.0854 28.5191 53.8627 28.5902C55.6385 28.6607 57.0789 29.9449 57.0797 31.4576L57.07 89.885Z"
						[attr.fill]="videoData.primaryColor" />
					<defs>
						<filter id="filter0_f_1_495" x="0.401855" y="0.733948" width="80.198" height="119.89"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_1_495" />
						</filter>
					</defs>
				</svg>
			</div>

			<!-- forward 10 -->
			<div *ngIf="videoData.enableForward10 && !loading" (click)="$event.stopImmediatePropagation(); moveForSeconds(10);"
				title="Forward 10sec" class="pointer">
				<svg xmlns="http://www.w3.org/2000/svg" width="90" height="98" viewBox="0 0 90 98" fill="none">
					<g filter="url(#filter0_f_31_132)">
						<path
							d="M65.8761 31.8761C64.9626 30.9626 64.0195 30.1715 63.0943 29.4517C62.7558 29.1776 62.3661 28.9738 61.9479 28.8522C61.5297 28.7306 61.0914 28.6936 60.6587 28.7434C60.226 28.7932 59.8076 28.9288 59.428 29.1422C59.0483 29.3556 58.7151 29.6427 58.4477 29.9864C58.1803 30.3302 57.9841 30.7239 57.8707 31.1444C57.7573 31.5649 57.7289 32.0038 57.7871 32.4354C57.8454 32.8671 57.9891 33.2827 58.2099 33.6581C58.4307 34.0335 58.7242 34.3611 59.0732 34.6218C59.8595 35.2336 60.5854 35.849 61.2443 36.508C70.2257 45.4893 70.2257 59.9493 61.2443 68.9306C52.263 77.912 37.803 77.912 28.8216 68.9306C19.8403 59.9493 19.8403 45.4893 28.8216 36.508C31.8729 33.4567 35.561 31.4796 39.449 30.5124L39.2432 30.7182C38.932 31.0207 38.684 31.3821 38.5137 31.7813C38.3433 32.1806 38.254 32.6097 38.2509 33.0437C38.2479 33.4777 38.3311 33.908 38.4958 34.3096C38.6605 34.7112 38.9033 35.0761 39.2102 35.383C39.5171 35.6899 39.882 35.9328 40.2836 36.0974C40.6852 36.2621 41.1155 36.3453 41.5495 36.3423C41.9836 36.3392 42.4127 36.2499 42.8119 36.0796C43.2111 35.9092 43.5725 35.6612 43.875 35.35L50.2302 28.9948L50.8228 28.4023C51.4369 27.788 51.7819 26.955 51.7819 26.0864C51.7819 25.2178 51.4369 24.3847 50.8228 23.7705L43.875 16.8228C43.5725 16.5115 43.2111 16.2635 42.8119 16.0932C42.4127 15.9228 41.9836 15.8335 41.5495 15.8305C41.1155 15.8274 40.6852 15.9106 40.2836 16.0753C39.882 16.24 39.5171 16.4829 39.2102 16.7898C38.9033 17.0967 38.6605 17.4615 38.4958 17.8631C38.3311 18.2647 38.2479 18.695 38.2509 19.1291C38.254 19.5631 38.3433 19.9922 38.5137 20.3914C38.684 20.7906 38.932 21.152 39.2432 21.4546L41.2923 23.5036C35.0374 24.2982 28.9819 27.084 24.1898 31.8761C12.7055 43.3604 12.7055 62.0782 24.1898 73.5625C35.6741 85.0468 54.3918 85.0468 65.8761 73.5625C77.3604 62.0782 77.3604 43.3604 65.8761 31.8761Z"
							[attr.fill]="videoData.secondaryColor" fill-opacity="0.6" />
					</g>
					<path
						d="M60.69 36.69C60.0034 36.0033 59.2946 35.4088 58.5993 34.8678C58.3449 34.6618 58.052 34.5086 57.7376 34.4172C57.4233 34.3258 57.0939 34.298 56.7687 34.3355C56.4436 34.3729 56.1291 34.4748 55.8438 34.6352C55.5584 34.7956 55.308 35.0113 55.107 35.2697C54.906 35.5281 54.7586 35.824 54.6734 36.14C54.5881 36.456 54.5668 36.7859 54.6105 37.1103C54.6543 37.4347 54.7623 37.7471 54.9283 38.0293C55.0943 38.3114 55.3148 38.5576 55.5771 38.7535C56.1681 39.2133 56.7136 39.6759 57.2089 40.1711C63.959 46.9213 63.959 57.789 57.2089 64.5392C50.4587 71.2893 39.591 71.2893 32.8408 64.5392C26.0907 57.789 26.0907 46.9213 32.8408 40.1711C35.1341 37.8779 37.906 36.392 40.8281 35.665L40.6734 35.8197C40.4395 36.0471 40.2531 36.3187 40.1251 36.6187C39.9971 36.9188 39.93 37.2412 39.9276 37.5675C39.9253 37.8937 39.9879 38.2171 40.1117 38.5189C40.2354 38.8207 40.418 39.0949 40.6486 39.3256C40.8793 39.5563 41.1535 39.7388 41.4553 39.8626C41.7572 39.9863 42.0806 40.0489 42.4068 40.0466C42.733 40.0443 43.0555 39.9772 43.3555 39.8491C43.6556 39.7211 43.9272 39.5347 44.1546 39.3008L48.9309 34.5244L49.3763 34.0791C49.8379 33.6174 50.0972 32.9913 50.0972 32.3385C50.0972 31.6857 49.8379 31.0596 49.3763 30.598L44.1546 25.3762C43.9272 25.1423 43.6556 24.9559 43.3555 24.8279C43.0555 24.6999 42.733 24.6328 42.4068 24.6305C42.0806 24.6281 41.7572 24.6907 41.4553 24.8145C41.1535 24.9382 40.8793 25.1208 40.6486 25.3514C40.418 25.5821 40.2354 25.8563 40.1117 26.1581C39.9879 26.46 39.9253 26.7834 39.9276 27.1096C39.93 27.4358 39.9971 27.7583 40.1251 28.0583C40.2531 28.3584 40.4395 28.63 40.6734 28.8574L42.2134 30.3974C37.5124 30.9945 32.9613 33.0883 29.3597 36.69C20.7284 45.3213 20.7284 59.389 29.3597 68.0203C37.991 76.6516 52.0587 76.6516 60.69 68.0203C69.3213 59.389 69.3213 45.3213 60.69 36.69Z"
						[attr.fill]="videoData.primaryColor" />
					<defs>
						<filter id="filter0_f_31_132" x="0.576599" y="0.830322" width="88.9128" height="96.3455"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="7.5" result="effect1_foregroundBlur_31_132" />
						</filter>
					</defs>
				</svg>
			</div>
		</div>
	</div>
	<!-- CONTROLS DISABLED -->
	<div *ngIf="!data.controls"
		[class.hidden]="!showPlayerControls"
		class="alter-controls">
		<div class="toolBox" >
			<div class="toolDiv" >

				<!-- sound -->
				<div class="volume_bar" title="Volume" (mouseover)="isSelectVisible = false;" *ngIf="data.soundfs">
					<div class="volume_popup">
						<div class="volume_bg" (click)="$event.stopImmediatePropagation(); setVolume($event);">
							<div style="width: 10px; border-radius: 100px;"
								[style]="'background-color: ' + videoData.primaryColor + '; height: ' + (player?.volume ?? 0) * 100 + '%;'"
								(click)="$event.stopImmediatePropagation(); setVolume($event);">
							</div>
						</div>
					</div>

					<div class="small-icon" *ngIf="data.soundfs && player.volume > 0"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); player.volume = 0;">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M14.3472 6.70449C14.5184 6.67672 14.6968 6.70568 14.8636 6.79424C15.1964 6.96943 15.4028 7.33879 15.4028 7.75907V21.9212C15.4028 22.3405 15.1955 22.7099 14.8636 22.8861C14.7376 22.9521 14.6052 22.9852 14.4742 22.9852C14.2582 22.9852 14.0458 22.8966 13.8731 22.7252L10.2436 19.1482H7.47913C6.78936 19.1482 6.22803 18.5039 6.22803 17.7122V11.9681C6.22803 11.1763 6.78936 10.532 7.47913 10.532H10.2436L13.8731 6.95504C14.0116 6.81766 14.176 6.73225 14.3472 6.70449ZM19.6416 9.57656C19.9614 9.59702 20.2752 9.75615 20.505 10.0515C21.5375 11.3746 22.1063 13.0748 22.1063 14.8401C22.1063 16.6055 21.5375 18.3057 20.505 19.6288C20.2581 19.9457 19.9152 20.1056 19.5715 20.1056C19.2746 20.1056 18.976 19.9852 18.7374 19.7391C18.2228 19.2097 18.1801 18.301 18.6413 17.7103C19.2619 16.9148 19.6041 15.8961 19.6041 14.8401C19.6041 13.7842 19.2619 12.7655 18.6413 11.9699C18.1801 11.3793 18.2228 10.4706 18.7374 9.94117C18.9948 9.67503 19.3217 9.55609 19.6416 9.57656Z"
								[attr.fill]="videoData.primaryColor" />
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
						</svg>
					</div>

					<div class="small-icon" *ngIf="data.soundfs && player.volume == 0"
						[style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); player.volume = 1;">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<path
								d="M15.1192 6.01015C15.2903 5.98239 15.4687 6.01135 15.6356 6.0999C15.9684 6.2751 16.1748 6.64446 16.1748 7.06474V21.2269C16.1748 21.6462 15.9675 22.0156 15.6356 22.1917C15.5096 22.2578 15.3772 22.2908 15.2462 22.2908C15.0302 22.2908 14.8178 22.2023 14.6451 22.0309L11.0156 18.4539H8.2511C7.56133 18.4539 7 17.8096 7 17.0179V11.2737C7 10.482 7.56133 9.83771 8.2511 9.83771H11.0156L14.6451 6.26071C14.7836 6.12333 14.948 6.03791 15.1192 6.01015ZM20.4135 8.88222C20.7334 8.90268 21.0471 9.06181 21.2769 9.35716C22.3095 10.6802 22.8783 12.3804 22.8783 14.1458C22.8783 15.9112 22.3095 17.6114 21.2769 18.9345C21.03 19.2513 20.6871 19.4113 20.3435 19.4113C20.0466 19.4113 19.748 19.2908 19.5094 19.0448C18.9948 18.5154 18.9521 17.6067 19.4133 17.016C20.0339 16.2204 20.3761 15.2018 20.3761 14.1458C20.3761 13.0898 20.0339 12.0712 19.4133 11.2756C18.9521 10.6849 18.9948 9.77626 19.5094 9.24684C19.7667 8.98069 20.0937 8.86176 20.4135 8.88222Z"
								[attr.fill]="videoData.primaryColor" />
							<path
								d="M19.582 22.4193C19.8004 22.8498 19.5604 23.3903 19.0451 23.627C18.5298 23.8638 17.9347 23.7078 17.7158 23.2775L9.26349 6.66983C9.04482 6.23988 9.28525 5.69899 9.80069 5.46204C10.3156 5.22509 10.9108 5.38166 11.1299 5.81148L19.582 22.4193Z"
								[attr.fill]="videoData.primaryColor" />
						</svg>
					</div>
				</div>

				<!-- unmute label -->
				<span (click)="$event.stopImmediatePropagation(); player.muted = false" class="unmute_label"
					style="bottom: 50px; z-index: 20"
					*ngIf="currentPlayCountdown || (videoData.showUnmute && player.muted)">{{videoData.unmuteLabel}}</span>

				<!-- fullscreen -->
				<div *ngIf="fullscreenAllowed() && data.soundfs && !videoData.floatingEnabled">
					<div class="small-icon"
						*ngIf="!isFullscreen"
						title="Fullscreen" [style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); openFullscreen();">
						<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="15" cy="15" r="14.5" [attr.stroke]="videoData.primaryColor" />
							<path
								d="M7.93367 17.8513H5.9502V21.8182C5.9502 22.9091 6.84276 23.8017 7.93367 23.8017H11.9006V21.8182H7.93367M7.93367 7.93391H11.9006V5.95044H7.93367C6.84276 5.95044 5.9502 6.843 5.9502 7.93391V11.9009H7.93367M21.818 5.95044H17.851V7.93391H21.818V11.9009H23.8014V7.93391C23.8014 6.843 22.9089 5.95044 21.818 5.95044ZM21.818 21.8182H17.851V23.8017H21.818C22.9089 23.8017 23.8014 22.9091 23.8014 21.8182V17.8513H21.818"
								[attr.fill]="videoData.primaryColor" />
						</svg>

					</div>

					<div class="small-icon"
						*ngIf="isFullscreen"
						title="Exit Fullscreen" [style]="'color: ' + videoData.primaryColor + ';'"
						(click)="$event.stopImmediatePropagation(); closeFullscreen();">
						<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
							<circle cx="15" cy="15" r="15" [attr.fill]="videoData.primaryColor" />
							<path
								d="M23.8512 11.9504L19.8843 11.9504C18.7934 11.9504 17.9008 11.0578 17.9008 9.96694L17.9008 6L19.8843 6L19.8843 9.96694L23.8512 9.96694L23.8512 11.9504Z"
								fill="white" />
							<path
								d="M11.8512 6L11.8512 9.96694C11.8512 11.0579 10.9587 11.9504 9.86776 11.9504L5.90081 11.9504L5.90081 9.96694L9.86776 9.96694L9.86776 6L11.8512 6Z"
								fill="white" />
							<path
								d="M5.90082 18H9.86776C10.9587 18 11.8512 18.8926 11.8512 19.9835V23.9504H9.86776V19.9835H5.90082V18Z"
								fill="white" />
							<path
								d="M17.9008 23.9504L17.9008 19.9835C17.9008 18.8926 18.7934 18 19.8843 18L23.8512 18L23.8512 19.9835L19.8843 19.9835L19.8843 23.9504L17.9008 23.9504Z"
								fill="white" />
						</svg>
					</div>
				</div>

			</div>
		</div>

		<!-- play/pause -->
		<div class="center-controls" *ngIf="showPlayerControls">

			<mat-spinner 
			*ngIf="loading && (!canPlay || (canPlay && !player.paused))" 
			[style.--mdc-circular-progress-active-indicator-color]="videoData.primaryColor">
		  </mat-spinner>
			<!-- play -->
			<div *ngIf="(data.allowPause || !data.autoplay) && (player.paused && (!loading || canPlay))" class="pointer" title="Play"
				(click)="$event.stopImmediatePropagation(); player.play(); unmuteAction();">
				<svg xmlns="http://www.w3.org/2000/svg" width="131" height="140" viewBox="0 0 131 140" fill="none">
					<g filter="url(#filter0_f_31_126)">
						<path
							d="M98 64.8038C102 67.1132 102 72.8868 98 75.1962L39.5 108.971C35.5 111.281 30.5 108.394 30.5 103.775L30.5 36.225C30.5 31.6062 35.5 28.7195 39.5 31.0289L98 64.8038Z"
							fill="white" fill-opacity="0.6" />
					</g>
					<g filter="url(#filter1_d_31_126)">
						<path
							d="M91 64.5707C95 66.8801 95 72.6536 91 74.963L43.3497 102.474C39.3497 104.783 34.3497 101.897 34.3497 97.2777L34.3497 42.2559C34.3497 37.6371 39.3497 34.7504 43.3497 37.0598L91 64.5707Z"
							[attr.fill]="videoData.primaryColor" />
					</g>
					<defs>
						<filter id="filter0_f_31_126" x="0.5" y="0.216064" width="130.5" height="139.568"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="15" result="effect1_foregroundBlur_31_126" />
						</filter>
						<filter id="filter1_d_31_126" x="30.3497" y="36.2471" width="67.6503" height="75.0396"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix in="SourceAlpha" type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
							<feOffset dy="4" />
							<feGaussianBlur stdDeviation="2" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_31_126" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_31_126" result="shape" />
						</filter>
					</defs>
				</svg>
			</div>

			<!-- pause -->
			<div *ngIf=" data.allowPause && !player.paused && !loading " class="pointer" title="Pause"
				(click)="$event.stopImmediatePropagation(); player.pause();">

				<svg xmlns="http://www.w3.org/2000/svg" width="81" height="121" viewBox="0 0 81 121" fill="none">
					<g filter="url(#filter0_f_1_495)">
						<path
							d="M28.4456 97.3566C28.4432 99.2486 26.6438 100.709 24.423 100.62C22.2022 100.531 20.4012 98.9276 20.4019 97.0353L20.4126 24.0009C20.4134 22.1104 22.2149 20.6488 24.4365 20.7378C26.6563 20.8259 28.4567 22.4311 28.4577 24.322L28.4456 97.3566Z"
							fill="white" />
						<path
							d="M60.5878 97.3566C60.5854 99.2486 58.786 100.709 56.5652 100.62C54.3443 100.531 52.5434 98.9276 52.544 97.0353L52.5547 24.0009C52.5555 22.1104 54.357 20.6488 56.5786 20.7378C58.7985 20.8259 60.5989 22.4311 60.5999 24.322L60.5878 97.3566Z"
							fill="white" />
					</g>
					<path
						d="M31.3564 89.885C31.3545 91.3985 29.915 92.5672 28.1383 92.4957C26.3617 92.4242 24.9209 91.1418 24.9215 89.6279L24.93 31.2007C24.9306 29.6884 26.3718 28.5191 28.1491 28.5902C29.925 28.6607 31.3653 29.9449 31.3661 31.4576L31.3564 89.885Z"
						[attr.fill]="videoData.primaryColor" />
					<path
						d="M57.07 89.885C57.0681 91.3985 55.6285 92.5672 53.8519 92.4957C52.0752 92.4242 50.6345 91.1418 50.635 89.6279L50.6436 31.2007C50.6442 29.6884 52.0854 28.5191 53.8627 28.5902C55.6385 28.6607 57.0789 29.9449 57.0797 31.4576L57.07 89.885Z"
						[attr.fill]="videoData.primaryColor" />
					<defs>
						<filter id="filter0_f_1_495" x="0.401855" y="0.733948" width="80.198" height="119.89"
							filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
							<feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_1_495" />
						</filter>
					</defs>
				</svg>
			</div>
		</div>
	</div>
</div>
<span class="video_name" *ngIf="player.paused && videoData.showLabel">{{videoData.name}}</span>
